import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  VStack,
  HStack,
  Image,
  Flex,
} from "@chakra-ui/react";
import React from "react";
import { PieChart, Pie, Legend, Cell, ResponsiveContainer } from "recharts";

const PieCharts = ({ info }) => {
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#ff7f0e",
    "#9467bd",
    "#8c564b",
    "#e377c2",
    "#7f7f7f",
    "#bcbd22",
    "#17becf",
  ];

  const totalValue = info?.reduce(
    (acc, asset) => acc + asset.estimated_balance * asset.price,
    0
  );

  // Prepare data for Recharts
  const pieChartData = info?.map((asset, index) => ({
    name: asset.asset.symbol,
    value: ((asset.estimated_balance * asset.price) / totalValue) * 100, // calculate percentage
    color: COLORS[index % COLORS.length], // assign colors
  }));

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div>
      <Box
        color="gray.500"
        fontSize="14px"
        _hover={{ cursor: "pointer" }}
        onClick={onOpen}
      >
        Show holdings ratios
      </Box>
      <Modal
        size={{ base: "full", md: "md" }}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent bg={{ base: "black", md: "#0e0f10" }} borderRadius="20px">
          <ModalHeader>{/* Holdings Breakdown */}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart width={800} height={400}>
                  <Pie
                    data={pieChartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={80}
                    paddingAngle={5}
                    dataKey="value"
                    nameKey="name"
                    label
                  >
                    {pieChartData?.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>{" "}
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </VStack>
            <Box mt="20px" h="300px" overflow="auto">
              <Box fontSize="20px">Your assets</Box>
              {info?.map((e, i) => {
                return (
                  <Box
                    mt="10px"
                    w="100%"
                    p="10px"
                    bg="#212121"
                    borderRadius="10px"
                  >
                    <HStack w="100%" justifyContent="space-between">
                      <HStack>
                        <Image
                          src={e?.asset?.logo}
                          boxSize="30px"
                          borderRadius="5px"
                        />
                        <Flex
                          alignItems="flex-start"
                          justifyContent="flex-start"
                          flexDir="column"
                        >
                          {" "}
                          <Box color="gray.500" fontSize="10px">
                            {e?.asset?.name}
                          </Box>
                          <Box>${e?.asset?.symbol}</Box>
                        </Flex>
                      </HStack>
                      <Box fontSize="14px">
                        {" "}
                        {Number(pieChartData[i]?.value)?.toFixed(3)}%
                      </Box>
                    </HStack>
                  </Box>
                );
              })}
            </Box>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default PieCharts;
